import { CellContext } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FolderPermissionResponse } from '../../../../api/types.gen';
import { EditPermissionLevel } from './PermissionEnums';
import { PermissionTableFeatures } from './permissionTableFeatures';

interface EditPermissionCellProps {
  cellContext: CellContext<PermissionTableFeatures, FolderPermissionResponse, EditPermissionLevel>;
}

export function EditPermissionCell({ cellContext }: EditPermissionCellProps) {
  const { t } = useTranslation('', { keyPrefix: 'permissions' });
  const value = cellContext.getValue();

  switch (value) {
    case EditPermissionLevel.Own:
      return <>{t('editPermissionsOwn')}</>;
    case EditPermissionLevel.All:
      return <>{t('editPermissionsAll')}</>;
    default:
      return <>{t('editPermissionsNone')}</>;
  }
}
